import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { FormRow } from '@zocdoc-frontend-common/styles-grid';
import { PhoneNumberWithDelayedImport } from '@zocdoc-frontend-common/components-phonenumber/PhoneNumberWithDelayedImport';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';

import AddPhoneBox from '../../components/AddPhoneBox';

const PhoneInputBlockView = ({
    hasError,
    onAddOrEditPhoneNumberClick,
    phoneNumber,
    phoneNumberRequired,
    trackClickAddPhone,
    trackClickEditPhone,
}) => {
    return (
        <FormRow>
            <FormLabel>Phone number where the doctor can contact you</FormLabel>
            {phoneNumberRequired ? (
                <AddPhoneBox
                    hasError={hasError}
                    onClick={() => {
                        trackClickAddPhone();
                        onAddOrEditPhoneNumberClick();
                    }}
                />
            ) : (
                <PhoneNumberWithDelayedImport
                    initialValue={phoneNumber}
                    onEdit={() => {
                        trackClickEditPhone();
                        onAddOrEditPhoneNumberClick();
                    }}
                    presentationMode
                />
            )}
        </FormRow>
    );
};

PhoneInputBlockView.propTypes = {
    hasError: PropTypes.bool.isRequired,
    onAddOrEditPhoneNumberClick: PropTypes.func.isRequired,
    phoneNumber: PropTypes.string,
    phoneNumberRequired: PropTypes.bool.isRequired,
    trackClickAddPhone: PropTypes.func,
    trackClickEditPhone: PropTypes.func,
};

const FormLabel = styled.div`
    font: 13px/24px ${FontFamily.SharpSansSemibold};
    padding-bottom: 4px;
`;

export default PhoneInputBlockView;
